import { IGame } from 'src/app/models/game';

export const theRinging: IGame = {
    embedId: 1414070,
    name: 'The Ringing',
    url: 'the-ringing'
};
